import { useState, useCallback, useEffect, useRef } from 'react';
import './Table3.css'


const createHeaders = (headers) => {
    return headers.map((item) => ({
        text: item,
        ref: useRef(),
    }));

}
export const Table = ({ dataSource, columns, headers, minCellWidth, children }) => {

    const [tableHeight, setTableHeight] = useState('auto');
    const [activeIndex, setActiveIndex] = useState(null);
    const tableElement = useRef(null);
    const columns1 = createHeaders(headers);



    const mouseDown = (index) => {
        setActiveIndex(index);
    }

    const mouseMove = useCallback((e) => {
        // Return an array of px values
        const gridColumns = columns1.map((col, i) => {
            if (i === activeIndex) {
                // Calculate the column width
                const width = e.clientX - col.ref.current.offsetLeft;

                if (width >= minCellWidth) {
                    return `${width}px`;
                }
            }

            // Otherwise return the previous width (no changes)
            return `${col.ref.current.offsetWidth}px`;
        });

        // Assign the px values to the table
        tableElement.current.style.gridTemplateColumns = `${gridColumns.join(' ')}`;
    }, [activeIndex, columns1, minCellWidth]);

    const removeListeners = useCallback(() => {
        window.removeEventListener('mousemove', mouseMove);
        window.removeEventListener('mouseup', removeListeners);
    }, [mouseMove]);

    const mouseUp = useCallback(() => {
        setActiveIndex(null);
        removeListeners();
    }, [setActiveIndex, removeListeners]);



    useEffect(() => {
        setTableHeight(tableElement.current.offsetHeight);
    }, []);


    useEffect(() => {
        if (activeIndex !== null) {
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
        }

        return () => {
            removeListeners();
        }
    }, [activeIndex, mouseMove, mouseUp, removeListeners]);


    let gridTemplateColumns = '';
    headers.map(x => gridTemplateColumns += 'minmax(150px, 1fr) ');
    return (
        <div className="table-wrapper">
            <table
                style={ { gridTemplateColumns: gridTemplateColumns }}
                className="resizeable-table" ref={tableElement}>
                <thead>
                    <tr>
                        {columns1.map(({ ref, text }, i) => (
                            <th ref={ref} key={i}>
                                <span>{text}</span>
                                <div
                                    style={{ height: tableHeight }}
                                    onMouseDown={() => mouseDown(i)}
                                    className={`resize-handle ${activeIndex === i ? 'active' : 'idle'}`}
                                />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataSource.map((x, i) => {
                        return (<tr  key={i}   >
                            {columns(x,i) }
                        </tr>);
                    })}
                </tbody>
              
            </table>
        </div>
    );
}

export const Column = ( props) => {


    return (
        <td {...props}> {props.children}  </td>
    );
}
